import React, { createContext, useContext, useState, useCallback } from "react";

const dict = {
  it: {
    appName: "T2WORK KITCHEN",
    login: "Accedi",
    register: "Registrati",
    logout: "Esci",
    email: "Email",
    password: "Password",
    name: "Nome e cognome",
    businessName: "Nome attività",
    businessType: "Tipo attività",
    seats: "Coperti medi",
    continueGoogle: "Continua con Google",
    noAccount: "Non hai un account?",
    hasAccount: "Hai già un account?",
    loginSubtitle: "Il sistema operativo intelligente della tua cucina",
    onboardingTitle: "Configura la tua attività",
    onboardingSubtitle: "Pochi dati per iniziare: potrai modificare tutto in seguito.",
    startNow: "Inizia ora",
    nav: {
      dashboard: "Dashboard", products: "Magazzino", expirations: "Scadenze", waste: "Sprechi",
      temperatures: "Temperature", haccp: "HACCP", nonconformities: "Non Conformità",
      notifications: "Notifiche", kitchen: "Kitchen Mode", pricing: "Abbonamento",
    },
    pay: {
      title: "Abbonamento", subtitle: "Scegli il piano adatto alla tua attività. Pagamento sicuro con Stripe.",
      monthly: "Mensile", yearly: "Annuale", perMonth: "/mese", perYear: "/anno",
      subscribe: "Attiva", currentPlan: "Piano attivo", popular: "Più scelto",
      successTitle: "Pagamento completato!", successBody: "Il tuo piano è attivo. Benvenuto a bordo.",
      checking: "Verifica del pagamento in corso...",
      failedTitle: "Pagamento non completato", backDashboard: "Torna alla dashboard",
      cancelTitle: "Pagamento annullato", cancelBody: "Nessun addebito effettuato. Puoi riprovare quando vuoi.",
      backPlans: "Vedi i piani", testNote: "Ambiente di test Stripe — carta 4242 4242 4242 4242.",
      saveYearly: "2 mesi gratis",
      trialActive: "Prova PRO attiva", trialDaysLeft: "giorni rimasti", trialFree: "€0 · nessuna carta richiesta",
      trialExpired: "Prova terminata", trialExpiredBody: "Il periodo di prova di 5 giorni è terminato. Attiva un piano per continuare a usare tutte le funzioni.",
      trialBannerBody: "Hai 5 giorni di prova gratuita con tutte le funzioni del piano PRO. Nessuna carta richiesta.",
    },
    land: {
      badge: "Per ristoranti, pizzerie, bar, hotel e mense",
      heroTitle: "Il sistema operativo intelligente della tua cucina",
      heroSub: "HACCP digitale, magazzino, scadenze, sprechi, temperature e assistente AI. Il personale registra in pochi tocchi, il sistema calcola e controlla il resto.",
      ctaTrial: "Prova gratis 5 giorni",
      ctaLogin: "Accedi",
      noCard: "Nessuna carta richiesta · Funzioni PRO incluse",
      featuresTitle: "Tutto quello che serve alla tua cucina",
      f1t: "HACCP digitale", f1d: "Checklist configurabili, temperature con alert automatici e non conformità tracciate.",
      f2t: "Magazzino intelligente", f2d: "Alimentare e non alimentare, carichi e scarichi in pochi tocchi, scorte minime con avvisi.",
      f3t: "Scadenze FEFO", f3d: "First Expired First Out: vedi subito cosa scade oggi, domani e nei prossimi 7 giorni.",
      f4t: "Sprechi sotto controllo", f4d: "Registra gli sprechi con causa e costo, scopri dove stai perdendo margine.",
      f5t: "Assistente AI", f5d: "Scrivi 'ho ricevuto 10 kg di pomodori': il sistema aggiorna tutto dopo la tua conferma.",
      f6t: "Notifiche intelligenti", f6d: "Solo avvisi utili: temperature anomale, scorte basse, controlli mancanti, prodotti in scadenza.",
      pricingTitle: "Prezzi semplici, nessuna sorpresa",
      perMonth: "/mese", start: "Inizia ora", popular: "Più scelto",
      footer: "Un prodotto",
      plan_solo_0: "1 sede · 3 utenti", plan_solo_1: "Magazzino, scadenze, sprechi", plan_solo_2: "HACCP + assistente AI",
      plan_pro_0: "1 sede · 15 utenti", plan_pro_1: "Tutto di Solo", plan_pro_2: "Report sprechi avanzati", plan_pro_3: "Notifiche prioritarie",
      plan_multi_0: "Fino a 10 sedi · 50 utenti", plan_multi_1: "Tutto di Pro", plan_multi_2: "Vista consolidata sedi", plan_multi_3: "Supporto prioritario", plan_multi_4: "Onboarding dedicato",
    },
    dash: {
      today: "OGGI", allOk: "Tutto in regola", attention: "Attenzione", critical: "Intervento necessario",
      haccpControls: "Controlli HACCP", criticalStock: "Giacenze critiche", expiring: "Prodotti in scadenza",
      temperatures: "Temperature", wasteToday: "Spreco oggi", wasteMonth: "Spreco questo mese",
      openNc: "Non conformità aperte", inventoryValue: "Valore magazzino",
      completed: "completati", pending: "da fare", outOfRange: "fuori range",
      quickActions: "Azioni rapide", aiPlaceholder: "Cosa vuoi fare? Es. 'Ho ricevuto 10 kg di pomodori' oppure 'Buttati 2 kg di mozzarella scaduta'",
      aiInterpreting: "Interpretazione in corso...",
      aiProposal: "Ho interpretato così — controlla e conferma:",
      confirm: "Conferma", edit: "Modifica", cancel: "Annulla", execute: "Esegui",
      expiringToday: "scadono oggi", expired: "scaduti", within3: "entro 3 giorni",
    },
    actions: {
      recordTemp: "Registra temperatura", loadGoods: "Carica merce", logWaste: "Registra spreco",
      viewExpirations: "Vedi scadenze", haccpCheck: "Controllo HACCP", inventory: "Inventario",
    },
    products: {
      title: "Magazzino", food: "Alimentare", nonFood: "Non alimentare", add: "Nuovo prodotto",
      name: "Prodotto", category: "Categoria", unit: "Unità", qty: "Giacenza", minQty: "Scorta minima",
      idealQty: "Scorta ideale", cost: "Costo medio", supplier: "Fornitore", expiry: "Scadenza",
      load: "Carica", unload: "Scarica", quantity: "Quantità", price: "Prezzo", note: "Nota",
      search: "Cerca prodotto...", lowStock: "Scorta bassa", outOfStock: "Terminato",
      allergens: "Allergeni", location: "Ubicazione", save: "Salva", delete: "Elimina",
      confirmDelete: "Eliminare questo prodotto?",
    },
    exp: {
      title: "Scadenze", today: "Scadono oggi", tomorrow: "Scadono domani", in3: "Entro 3 giorni",
      in7: "Entro 7 giorni", expiredB: "Scaduti", value: "Valore", days: "gg", noItems: "Nessun prodotto in questa fascia",
      fefoNote: "Logica FEFO: usa prima ciò che scade prima.",
    },
    waste: {
      title: "Sprechi", log: "Registra spreco", product: "Prodotto", reason: "Causa", shift: "Turno",
      today: "Spreco oggi", week: "Questa settimana", month: "Questo mese", year: "Quest'anno",
      byReason: "Principali cause", history: "Ultimi sprechi registrati", value: "Valore",
      reasons: { scadenza: "Scadenza", errore_preparazione: "Errore preparazione", avanzo_cliente: "Avanzo cliente", sovrapproduzione: "Sovrapproduzione", deterioramento: "Deterioramento", errore_conservazione: "Errore conservazione", prodotto_danneggiato: "Prodotto danneggiato", altro: "Altro" },
    },
    temps: {
      title: "Controllo Temperature", record: "Registra", corrective: "Azione correttiva",
      history: "Ultime rilevazioni", outOfRange: "FUORI RANGE", lastReading: "Ultima rilevazione",
      noReading: "Nessuna rilevazione", range: "Range", operator: "Operatore", addEquipment: "Nuova attrezzatura",
      alertTitle: "ATTENZIONE — Temperatura fuori dal range configurato",
    },
    haccp: {
      title: "HACCP", runCheck: "Avvia controllo", complete: "Completa controllo",
      templates: "Checklist", newTemplate: "Nuova checklist", items: "Controlli (uno per riga)",
      shift: "Turno", opening: "Apertura", closing: "Chiusura", service: "Servizio",
      recentChecks: "Controlli recenti", anomalies: "anomalie", estTime: "Tempo previsto",
      disclaimer: "Il sistema aiuta la registrazione dei controlli: la conformità resta responsabilità dell'attività secondo il proprio piano HACCP.",
    },
    nc: {
      title: "Non Conformità", new: "Nuova non conformità", category: "Categoria", problem: "Problema",
      corrective: "Azione correttiva", assigned: "Responsabile", status: "Stato",
      aperta: "Aperta", in_gestione: "In gestione", risolta: "Risolta", markProgress: "Prendi in carico", markResolved: "Segna risolta",
    },
    notif: {
      title: "Notifiche", markAllRead: "Segna tutte lette", empty: "Nessuna notifica",
      info: "Info", warning: "Attenzione", urgent: "Urgente",
    },
    kitchen: {
      title: "Kitchen Mode", subtitle: "Operazioni rapide durante il servizio",
      temps: "Temperature", waste: "Spreco", expirations: "Scadenze", haccp: "Controlli", stock: "Magazzino",
      exit: "Esci da Kitchen Mode",
    },
    common: {
      save: "Salva", cancel: "Annulla", close: "Chiudi", loading: "Caricamento...",
      language: "Lingua", error: "Errore", success: "Fatto", today: "Oggi",
      delete: "Elimina", confirmDelete: "Eliminare questo inserimento? L'operazione annulla l'azione registrata.",
    },
  },
  en: {
    appName: "T2WORK KITCHEN",
    login: "Sign in",
    register: "Sign up",
    logout: "Log out",
    email: "Email",
    password: "Password",
    name: "Full name",
    businessName: "Business name",
    businessType: "Business type",
    seats: "Average covers",
    continueGoogle: "Continue with Google",
    noAccount: "No account yet?",
    hasAccount: "Already have an account?",
    loginSubtitle: "The intelligent operating system for your kitchen",
    onboardingTitle: "Set up your business",
    onboardingSubtitle: "Just a few details to get started — you can change everything later.",
    startNow: "Start now",
    nav: {
      dashboard: "Dashboard", products: "Inventory", expirations: "Expirations", waste: "Waste",
      temperatures: "Temperatures", haccp: "HACCP", nonconformities: "Non-Conformities",
      notifications: "Notifications", kitchen: "Kitchen Mode", pricing: "Subscription",
    },
    pay: {
      title: "Subscription", subtitle: "Choose the right plan for your business. Secure payment with Stripe.",
      monthly: "Monthly", yearly: "Yearly", perMonth: "/month", perYear: "/year",
      subscribe: "Subscribe", currentPlan: "Current plan", popular: "Most popular",
      successTitle: "Payment completed!", successBody: "Your plan is active. Welcome aboard.",
      checking: "Verifying your payment...",
      failedTitle: "Payment not completed", backDashboard: "Back to dashboard",
      cancelTitle: "Payment cancelled", cancelBody: "No charge was made. You can try again anytime.",
      backPlans: "View plans", testNote: "Stripe test environment — card 4242 4242 4242 4242.",
      saveYearly: "2 months free",
      trialActive: "PRO trial active", trialDaysLeft: "days left", trialFree: "€0 · no card required",
      trialExpired: "Trial ended", trialExpiredBody: "Your 5-day free trial has ended. Activate a plan to keep using all features.",
      trialBannerBody: "You have a 5-day free trial with all PRO plan features. No card required.",
    },
    land: {
      badge: "For restaurants, pizzerias, bars, hotels and canteens",
      heroTitle: "The intelligent operating system for your kitchen",
      heroSub: "Digital HACCP, inventory, expirations, waste, temperatures and AI assistant. Your staff records in a few taps, the system calculates and checks the rest.",
      ctaTrial: "5-day free trial",
      ctaLogin: "Sign in",
      noCard: "No card required · PRO features included",
      featuresTitle: "Everything your kitchen needs",
      f1t: "Digital HACCP", f1d: "Configurable checklists, temperature alerts and tracked non-conformities.",
      f2t: "Smart inventory", f2d: "Food and non-food, quick load/unload, minimum stock alerts.",
      f3t: "FEFO expirations", f3d: "First Expired First Out: instantly see what expires today, tomorrow and within 7 days.",
      f4t: "Waste under control", f4d: "Log waste with reason and cost, discover where you're losing margin.",
      f5t: "AI assistant", f5d: "Write 'received 10 kg of tomatoes': the system updates everything after your confirmation.",
      f6t: "Smart notifications", f6d: "Only useful alerts: abnormal temperatures, low stock, missing checks, expiring products.",
      pricingTitle: "Simple pricing, no surprises",
      perMonth: "/month", start: "Start now", popular: "Most popular",
      footer: "A product by",
      plan_solo_0: "1 location · 3 users", plan_solo_1: "Inventory, expirations, waste", plan_solo_2: "HACCP + AI assistant",
      plan_pro_0: "1 location · 15 users", plan_pro_1: "Everything in Solo", plan_pro_2: "Advanced waste reports", plan_pro_3: "Priority notifications",
      plan_multi_0: "Up to 10 locations · 50 users", plan_multi_1: "Everything in Pro", plan_multi_2: "Multi-location overview", plan_multi_3: "Priority support", plan_multi_4: "Dedicated onboarding",
    },
    dash: {
      today: "TODAY", allOk: "All good", attention: "Attention", critical: "Action needed",
      haccpControls: "HACCP controls", criticalStock: "Critical stock", expiring: "Expiring products",
      temperatures: "Temperatures", wasteToday: "Waste today", wasteMonth: "Waste this month",
      openNc: "Open non-conformities", inventoryValue: "Inventory value",
      completed: "completed", pending: "to do", outOfRange: "out of range",
      quickActions: "Quick actions", aiPlaceholder: "What do you want to do? E.g. 'Received 10 kg of tomatoes' or 'Threw away 2 kg expired mozzarella'",
      aiInterpreting: "Interpreting...",
      aiProposal: "Here's what I understood — review and confirm:",
      confirm: "Confirm", edit: "Edit", cancel: "Cancel", execute: "Execute",
      expiringToday: "expire today", expired: "expired", within3: "within 3 days",
    },
    actions: {
      recordTemp: "Record temperature", loadGoods: "Load goods", logWaste: "Log waste",
      viewExpirations: "View expirations", haccpCheck: "HACCP check", inventory: "Stock count",
    },
    products: {
      title: "Inventory", food: "Food", nonFood: "Non-food", add: "New product",
      name: "Product", category: "Category", unit: "Unit", qty: "Stock", minQty: "Min stock",
      idealQty: "Ideal stock", cost: "Avg cost", supplier: "Supplier", expiry: "Expiry",
      load: "Load", unload: "Unload", quantity: "Quantity", price: "Price", note: "Note",
      search: "Search product...", lowStock: "Low stock", outOfStock: "Out of stock",
      allergens: "Allergens", location: "Location", save: "Save", delete: "Delete",
      confirmDelete: "Delete this product?",
    },
    exp: {
      title: "Expirations", today: "Expiring today", tomorrow: "Expiring tomorrow", in3: "Within 3 days",
      in7: "Within 7 days", expiredB: "Expired", value: "Value", days: "d", noItems: "No products in this range",
      fefoNote: "FEFO logic: use what expires first, first.",
    },
    waste: {
      title: "Waste", log: "Log waste", product: "Product", reason: "Reason", shift: "Shift",
      today: "Waste today", week: "This week", month: "This month", year: "This year",
      byReason: "Top causes", history: "Recent waste records", value: "Value",
      reasons: { scadenza: "Expiry", errore_preparazione: "Preparation error", avanzo_cliente: "Customer leftover", sovrapproduzione: "Overproduction", deterioramento: "Spoilage", errore_conservazione: "Storage error", prodotto_danneggiato: "Damaged product", altro: "Other" },
    },
    temps: {
      title: "Temperature Control", record: "Record", corrective: "Corrective action",
      history: "Recent readings", outOfRange: "OUT OF RANGE", lastReading: "Last reading",
      noReading: "No readings yet", range: "Range", operator: "Operator", addEquipment: "New equipment",
      alertTitle: "WARNING — Temperature outside configured range",
    },
    haccp: {
      title: "HACCP", runCheck: "Start check", complete: "Complete check",
      templates: "Checklists", newTemplate: "New checklist", items: "Checks (one per line)",
      shift: "Shift", opening: "Opening", closing: "Closing", service: "Service",
      recentChecks: "Recent checks", anomalies: "anomalies", estTime: "Estimated time",
      disclaimer: "The system helps record controls: compliance remains the responsibility of the business under its own HACCP plan.",
    },
    nc: {
      title: "Non-Conformities", new: "New non-conformity", category: "Category", problem: "Problem",
      corrective: "Corrective action", assigned: "Assignee", status: "Status",
      aperta: "Open", in_gestione: "In progress", risolta: "Resolved", markProgress: "Take over", markResolved: "Mark resolved",
    },
    notif: {
      title: "Notifications", markAllRead: "Mark all read", empty: "No notifications",
      info: "Info", warning: "Warning", urgent: "Urgent",
    },
    kitchen: {
      title: "Kitchen Mode", subtitle: "Quick operations during service",
      temps: "Temperatures", waste: "Waste", expirations: "Expirations", haccp: "Checks", stock: "Stock",
      exit: "Exit Kitchen Mode",
    },
    common: {
      save: "Save", cancel: "Cancel", close: "Close", loading: "Loading...",
      language: "Language", error: "Error", success: "Done", today: "Today",
      delete: "Delete", confirmDelete: "Delete this entry? This will undo the recorded action.",
    },
  },
};

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("sk_lang") || "it");
  const toggle = useCallback(() => {
    setLang((prev) => {
      const next = prev === "it" ? "en" : "it";
      localStorage.setItem("sk_lang", next);
      return next;
    });
  }, []);
  const t = useCallback((path) => {
    const parts = path.split(".");
    let node = dict[lang];
    for (const p of parts) node = node?.[p];
    if (node === undefined) {
      node = dict.it;
      for (const p of parts) node = node?.[p];
    }
    return node ?? path;
  }, [lang]);
  return (
    <LanguageContext.Provider value={{ lang, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  return useContext(LanguageContext);
}
